import {
  PlanState,
  WineClub,
  WineClubFrequency,
  WineClubPreference,
  WineClubVariant,
} from "./types";

export interface WineClubsState extends PlanState {
  clubOptions: WineClub[];
  changeClub: (club: WineClub) => void;
  variantOptions: WineClubVariant[];
  changeVariant: (variant: WineClubVariant) => void;
  preferenceOptions: WineClubPreference[];
  changePreference: (preference: WineClubPreference) => void;
  frequencyOptions: WineClubFrequency[];
  changeFrequency: (frequency: WineClubFrequency) => void;
  planName: string;
}

export const initialWineClubsState: PlanState = {};
